<template>
  <div class="app-content-wrapper">
    <div class="create-wrapper">
      <div>
        <el-image
          style="width: 224px; height: 119px"
          :src="require('../../../../assets/images/exchange.png')"></el-image>
      </div>
      <div class="right-wrapper">
        <div class="title">{{$t('message.exchange.exchangeMoney')}}</div>
        <div class="description margin-top-5">{{$t('message.exchange.addExchangeMoneyDescription')}}</div>
        <el-button v-permission="'wallet:exchange:add'" @click="addExchangeMoney" type="primary" class="margin-top-15" size="small">{{$t('message.exchange.exchangeMoney')}}</el-button>
      </div>
    </div>
    <div class="search-wrapper" style="padding-top: 20px;">
      <search-component ref="search"
                        :search-condition="searchCondition"
                        :search-buttons="searchButtonList"
                        :is-judgment-time="true"
                        :fuzzySearchPlaceholder="fuzzySearchPlaceholder"
                        router-name="/wallet/exchange">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition"
                    ref="table"
                    :first-parameters="getInitParams()"
                    :service-function="getExchangeList"
                    :is-first-automatic-visit="false"
                    router-name="/wallet/exchange">
      </custom-table>
    </div>
  </div>
</template>
<script>
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { initWeek, getWeekParams } from '@/utils/tools/time';
import { shallowClones } from '@/utils/tools/utils.js';
import BalancesService from '@/views/settlement/api/settlement-balance';
import ExchangeService from '@/views/wallet/api/exchange';

export default {
  components: { SearchComponent, CustomTable },
  data() {
    return {
      txnStatusList: null,
      fuzzySearchPlaceholder: `${this.$t('message.exchange.exchangeId')}`,
      searchCondition: [
        { // 创建时间
          key: ['startTime', 'endTime'],
          name: 'message.payee.creationTime',
          defValue: initWeek(),
          type: 'date_time',
        },
        { // 发起币种
          key: 'sellCurrency',
          name: 'message.exchange.originCurrency',
          type: 'select',
          defValue: '',
          options: [],
        },
        { // 目标币种
          key: 'buyCurrency',
          name: 'message.exchange.targetCurrency',
          type: 'select',
          defValue: '',
          options: [],
        },
      ],
      searchButtonList: [
        {
          type: 'download',
          permissionCode: 'wallet:exchange:download',
          func: async (param) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                await this.downLoadExchangeList(param);
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        },
      ],
      tableCondition: [
        { // Create date
          titleBar: { type: 'text', title: 'message.payee.creationTime' },
          key: 'createTime',
          type: 'text',
        },
        { // Exchange ID
          titleBar: { type: 'text', title: 'message.exchange.exchangeId' },
          key: 'id',
          type: 'text',
        },
        { // Currency exchange
          titleBar: { type: 'text', title: 'message.exchange.currencyExchange' },
          key: 'sellCurrency',
          type: 'text',
          textFunc: (row) => {
            return `${row.sellCurrency}/${row.buyCurrency}`;
          },
        },
        { // Rate
          titleBar: { type: 'text', title: 'message.exchange.rate' },
          key: 'convRate',
          type: 'text',
        },
        { // Sell
          titleBar: { type: 'text', title: 'message.exchange.sell' },
          key: 'sellAmount',
          type: 'text',
          textFunc: (row) => `${row.sellAmount} ${row.sellCurrency}`,
        },
        { // Buy
          titleBar: { type: 'text', title: 'message.exchange.buy' },
          key: 'buyAmount',
          type: 'text',
          textFunc: (row) => `${row.buyAmount} ${row.buyCurrency}`,
        },
        { // Delivery date
          titleBar: { type: 'text', title: 'message.exchange.deliveryDate' },
          key: 'deliveryTime',
          type: 'text',
        },
        { // 交易状态
          titleBar: { type: 'text', title: 'message.tableCommon.txnStatus' },
          key: 'txnStatus',
          type: 'text',
          textFunc: (data) => {
            return getEnantiomericValue(this.txnStatusList, data.txnStatus);
          },
          itemStyle: (data) => {
            if (data.txnStatus === 'Delivered') { // 成功
              return ';min-width: 58px;height: 27px;text-align: center;background:rgba(0,221,40,0.15);border-radius:4px;font-weight: 800;line-height: 27px;';
            } else if (data.txnStatus === 'Pending') { // 处理中
              return 'min-width: 58px;height: 27px;text-align: center;background:rgba(255,178,9,0.15);border-radius:4px;font-weight: 800;line-height: 27px;';
            } else if (data.txnStatus === 'Closed') { // Closed
              return 'min-width: 58px;height: 27px;text-align: center;background:#F1F5F7;border-radius:4px;font-weight: 800;line-height: 27px;';
            }
            return 'min-width: 58px;height: 27px;text-align: center;background:rgba(252,100,45,0.15);border-radius:4px;font-weight: 800;line-height: 27px;';
          },
        },
      ],
    };
  },
  async mounted() {
    BalancesService.getAccountBalances().then((data) => {
      this.$refs.search.setSearchSelectOptions('sellCurrency', initSelectedData(data, 'currency', 'currency')); // 发起币种
    });
    await GlobalData.getDictList(['MER_FX_TXN_STATUS', 'FX_CURRENCY']).then(res => {
      this.txnStatusList = initSelectedData(res.MER_FX_TXN_STATUS); // 交易状态
      this.$refs.search.setSearchSelectOptions('buyCurrency', initSelectedData(res.FX_CURRENCY, 'value', 'value')); // 目标币种
    });
    const table = this.$refs.table;
    table.httpGetList(shallowClones(shallowClones(table.firstParameters, table.additionalParameters), this.$route.query));
  },
  methods: {
    addExchangeMoney() {
      this.$router.push({
        path: '/wallet/exchange/add/amount',
      });
    },
    getInitParams() {
      const params = getWeekParams('startTime', 'endTime');
      return params;
    },
    ...ExchangeService,
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
.app-content-wrapper {
  color: $color-text-primary;
  .create-wrapper {
    display: flex;
    align-items: center;
    .right-wrapper {
      padding-left: 10px;
      .title {
        font-size: 16px;
        font-weight: 800;
        color: $color-text-primary;
        line-height: 28px;
      }
      .description {
        font-size: 14px;
        font-weight: normal;
        color: $color-text-primary;
        line-height: 21px;
      }
    }
  }
}
</style>
